<template>
  <div id="home">

    <pageHeader></pageHeader>
    <fixedHeader></fixedHeader>

    <div id="block-title">
      <div class="row align-center xsmall-collapse">
        <div class="xxlarge-12 columns text-center">
          <h2 class="page-title">Exposições</h2>
        </div>
      </div>
    </div>

    <lastShows></lastShows>
    <showsList></showsList>
  </div>

</template>

<script>
//Import resources
import axios from 'axios';

//import components
import pageHeader from '../blocks/pageHeader'
import fixedHeader from '../blocks/fixedHeader'
import lastShows from '../blocks/lastShows'
import showsList from '../blocks/showsList'

export default {
  name: 'home',
  components: {
    'pageHeader': pageHeader,
    'fixedHeader': fixedHeader,
    'lastShows' : lastShows,
    'showsList' : showsList
  },
  data () {
    return {
      loading: false
    }
  },
  methods: {
  },
  mounted () {
    TweenMax.to("#home", 2, { opacity: 1, delay: .5, ease:Power4.easeOut });
  }
}
</script>
<!-- styling for the component -->
<style lang="scss">

#home {
  opacity: 0;

  #block-title {
    margin: 100px 0 100px;
  }
}

@include max-screen(1080px) {
  #home {
    #block-title {
      margin: 100px 0 60px;
    }
  }
}

@include max-screen($xsmall) {
  #home {
    #block-title {
      margin: 80px 0 50px;
    }
  }
}

@include max-screen($xxsmall) {
  #home {
    #block-title {
      margin: 50px 0 30px;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/pages/Home.vue